export default {
  common: {
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    back: '返回',
    close: '关闭',
    add: '添加',
    send: '发送',
    sending: '发送中...',
    saving: '保存中...',
    loading: '加载中...',
    search: '搜索',
    update: '更新',
    create: '创建',
    creating: '创建中...',
    transfer: '转移',
    approve: '批准',
    reject: '拒绝',
    ok: '知道了',
    name: '姓名',
    username: '用户名',
    password: '密码',
    email: '电子邮件',
    date: '日期',
    status: '状态',
    type: '类型',
    quantity: '数量',
    description: '描述',
    project: '项目',
    task: '任务',
    logout: '退出登录',
    notifications: '通知',
    settings: '设置',
    draft: '草稿',
    sent: '已发送',
    active: '活跃',
    inactive: '非活跃',
    priority: '优先级',
    language: '语言',
    yes: '是',
    no: '否',
    error: '错误',
    success: '成功',
    warning: '警告',
    required: '必填',
    optional: '可选',
    all: '全部',
    none: '无',
    upload: '上传文件',
    download: '下载',
    print: '打印',
    actions: '操作',
    details: '详情',
    filters: '筛选',
    results: '结果',
    noResults: '未找到结果',
    total: '合计',
    of: '共',
    verified: '已验证',
    pending: '待处理',
    completed: '已完成',
    cancelled: '已取消',
  },

  auth: {
    login: '登录',
    loginTitle: '登录您的账户',
    logout: '退出登录',
    register: '注册',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    usernameOrEmail: '用户名或电子邮件',
    enterPassword: '输入密码',
    enterUsername: '输入用户名',
    loginError: '用户名或密码错误。',
    sessionExpired: '会话已过期，请重新登录。',
  },

  nav: {
    dashboard: '控制台',
    overview: '概览',
    documents: '文件',
    viewDocuments: '查看文件',
    manageProjects: '管理项目',
    viewProjects: '查看项目',
    manageUsers: '管理用户',
    viewUsers: '查看用户',
    manageWarehouse: '管理仓库',
    viewWarehouse: '查看仓库',
    manageMachinery: '管理机械',
    viewMachinery: '查看机械',
    manageSystem: '管理系统',
    projects: '项目',
    myProjects: '我的项目',
    myTasks: '我的任务',
    reports: '报告',
    drawings: '图纸',
    warehouse: '仓库',
    checkStock: '查询库存',
    requests: '申请',
    requestItem: '申请物品',
    tickets: '工单',
    messages: '消息',
    adminMode: '管理员模式',
    standardMode: '标准模式',
    analystMode: '分析师模式',
    createReport: '创建报告',
    createReports: '施工报告',
    dailyReport: '每日施工报告',
    incidentReport: '事故报告',
    safetySection: '职业安全',
    safetyDialog: '安全对话',
    workPermit: '危险作业许可证',
    occurrenceReport: '事件报告',
    settingsMenu: '设置',
  },

  profile: {
    editProfile: '编辑资料',
    displayName: '姓名',
    usernameLabel: '用户名',
    passwordLabel: '密码',
    changePassword: '修改密码',
    appearance: '外观',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    languageLabel: '语言',
    cropTitle: '裁剪头像',
    cropUse: '使用此区域',
    zoom: '缩放',
    currentPassword: '确认当前密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    emailVerified: '已验证',
    emailChange: '更改',
    emailSendCode: '发送验证码',
    emailConfirm: '确认',
    emailResend: '← 重新发送验证码',
    emailCancelChange: '取消',
    emailSending: '发送中...',
    emailVerifying: '验证中...',
    emailHint: '验证码已发送至 {email}，请检查收件箱和垃圾邮件。',
    emailSuccess: '电子邮件 {email} 验证成功。',
    emailInvalidError: '请输入有效的电子邮件地址。',
    emailGenericError: '发送验证码时出错。',
    emailInvalidCode: '验证码无效。',
    passwordFillAll: '请填写所有密码字段。',
    passwordWrong: '当前密码不正确。',
    passwordMismatch: '新密码确认不一致。',
    saveFillAll: '请填写姓名和用户名。',
    saveFinishPassword: '保存前请完成或取消密码修改。',
    avatarAlt: '头像',
  },

  dashboard: {
    overview: '概览',
    myProjects: '我的项目',
    myTasks: '我的任务',
    activeProjects: '进行中的项目',
    completedTasks: '已完成任务',
    pendingTasks: '待处理任务',
    recentActivity: '近期活动',
    noProjects: '未找到项目。',
    noTasks: '未找到任务。',
    createProject: '创建项目',
    projectName: '项目名称',
    startDate: '开始日期',
    endDate: '结束日期',
  },

  projects: {
    title: '项目',
    newProject: '新建项目',
    projectName: '项目名称',
    startDate: '开始',
    endDate: '结束',
    progress: '进度',
    team: '团队',
    gantt: '甘特图',
    files: '文件',
    tickets: '工单',
    warehouse: '仓库',
    dds: '安全会议',
    reports: '报告',
    noProjects: '暂无项目。',
    deleteConfirm: '确定要删除此项目吗？',
  },

  tasks: {
    title: '任务',
    newTask: '新建任务',
    taskName: '任务名称',
    assignee: '负责人',
    dependencies: '依赖关系',
    duration: '工期（天）',
    startDate: '开始',
    endDate: '结束',
    progress: '进度',
    addProgress: '记录进度',
    noTasks: '暂无任务。',
    blocked: '已阻塞',
    inProgress: '进行中',
    done: '已完成',
    deleteConfirm: '删除此任务？',
  },

  warehouse: {
    title: '仓库',
    stock: '库存',
    requestItem: '申请物品',
    requests: '申请',
    addItem: '添加物品',
    itemName: '物品名称',
    category: '类别',
    unit: '单位',
    available: '可用',
    reserved: '已预留',
    transferItem: '转移物品',
    reportDamage: '报告损坏',
    provideEquipment: '提供设备',
    noItems: '库存中暂无物品。',
    noRequests: '暂无申请。',
    approveRequest: '批准申请',
    rejectRequest: '拒绝申请',
    requestStatus: {
      pending: '待处理',
      approved: '已批准',
      rejected: '已拒绝',
      delivered: '已交付',
    },
  },

  safety: {
    title: '安全',
    dds: '安全会议',
    ddsTitle: '每日安全对话',
    newDds: '新建安全会议',
    occurrences: '事件',
    permits: '许可证',
    createDialog: '创建对话',
    createOccurrence: '记录事件',
    createPermit: '创建许可证',
    topic: '主题',
    presenter: '主持人',
    attendees: '参与者',
    date: '日期',
    noSafety: '暂无安全记录。',
  },

  tickets: {
    title: '工单',
    newTicket: '新建工单',
    subject: '主题',
    category: '类别',
    openedBy: '创建人',
    assignedTo: '分配给',
    openTickets: '开放工单',
    closedTickets: '已关闭工单',
    noTickets: '暂无工单。',
    status: {
      open: '开放',
      inProgress: '进行中',
      closed: '已关闭',
    },
  },

  users: {
    title: '用户',
    newUser: '新建用户',
    role: '职位',
    roles: {
      adminMaster: '超级管理员',
      adminObra: '项目管理员',
      user: '用户',
    },
    noUsers: '暂无用户。',
    deleteConfirm: '删除此用户？',
    manageRoles: '管理职位',
    manageUsers: '用户管理',
    userList: '用户列表',
  },

  system: {
    title: '系统设置',
    siteName: '系统名称',
    logo: '徽标',
    loginBackground: '登录背景',
    primaryColor: '主色调',
    save: '保存设置',
    saved: '设置已保存。',
  },

  reports: {
    title: '报告',
    daily: '每日报告',
    incident: '事故报告',
    noReports: '暂无报告。',
    createReport: '创建报告',
    date: '日期',
    author: '作者',
    content: '内容',
  },

  machinery: {
    title: '重型机械',
    newMachine: '新建设备',
    machineName: '名称',
    model: '型号',
    plate: '车牌号',
    status: '状态',
    noMachinery: '暂无设备。',
  },

  messenger: {
    title: '消息',
    newMessage: '新消息',
    noMessages: '暂无消息。',
    typeMessage: '输入消息...',
    send: '发送',
  },
}
